import { useEffect, useState } from "react";
import type { UseFirstCalculationPending } from "./types";

// Batches land one after another; a short idle between two is not the end of the run.
const SETTLED_MS = 1500;

export const useFirstCalculationPending: UseFirstCalculationPending = ({
  isSetupDone,
  routing,
  openRequestCount,
}) => {
  const [hasLanded, setHasLanded] = useState(false);
  const isIdle = routing.phase === "idle";

  useEffect(() => {
    if (!isSetupDone) {
      setHasLanded(false);
      return;
    }
    if (hasLanded) return;
    if (openRequestCount === 0) {
      setHasLanded(true);
      return;
    }
    if (!isIdle) return;
    const timer = window.setTimeout(() => setHasLanded(true), SETTLED_MS);
    return () => window.clearTimeout(timer);
  }, [isSetupDone, hasLanded, isIdle, openRequestCount]);

  return isSetupDone && !hasLanded;
};
